import { useMemo } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';

import Styles from './style.module.scss';
import { Tooltip } from '../../../../../../../Tooltip';
import withComponentName from '../../../../../../../../decorators/withComponentName';

const cx = classNames.bind(Styles);
export const PricingPlansTableBodyMobile = (props) => {
  const { content } = props;

  const tooltipContent = useMemo(() => {
    let tooltip = (
      <>
        This plan cannot be used to generate revenue directly or indirectly.
        {' '}
        <a
          href="https://help.cityfalcon.com/hc/en-us/articles/360033692854-non-commercial-use"
          rel="noreferrer"
          target="_blank"
        >
          See details.
        </a>
      </>
    );

    const useItem = content.find((item) => item.title === 'Use');
    if (!useItem || !useItem.bodyContent) {
      return tooltip;
    }

    if (useItem.bodyContent.text === 'Commercial Use') {
      tooltip = (
        <>
          Data and its derivatives may be used to generate revenue.&nbsp;
          <a
            href="https://help.cityfalcon.com/hc/en-us/articles/360033692854-non-commercial-use"
            rel="noreferrer"
            target="_blank"
          >
            Learn more
          </a>
          &nbsp;about commercial and non-commercial use.
        </>
      );
    }

    return tooltip;
  }, [content]);

  return (
    <tbody className={cx('tableBody__mobile')}>
      {
        content.map((item) => (
          <tr key={item.id} className={cx(item.className)}>
            <td colSpan={item.colSpan}>
              <div className={cx('cell__title', item.className)}>
                <div className={cx('title__content')}>
                  {item.title}
                </div>
                <div className={cx('title__question_help')}>
                  {item.withQuestionMark && (
                    <Tooltip className={cx('question__help--title', {
                      'sentiment-per-story': item.title === 'Sentiment per Story',
                      'key-headlines': item.title === 'Key Headlines',
                      'analyst-ratings': item.title === 'Analyst ratings',
                      'group-similar-stories': item.title === 'Group or Hide Similar Stories',
                      'investor-relations': item.title === 'Investor relations documents',
                      'private-company-insights': item.title === 'Private Company Insights',
                    })}
                    >
                      {tooltipContent}
                    </Tooltip>
                  )}
                  {item.textQuestionMark && (
                    <Tooltip className={cx('question__help--title', {
                      'sentiment-per-story': item.title === 'Sentiment per Story',
                      'key-headlines': item.title === 'Key Headlines',
                      'analyst-ratings': item.title === 'Analyst ratings',
                      'group-similar-stories': item.title === 'Group or Hide Similar Stories',
                      'investor-relations': item.title === 'Investor relations documents',
                      'private-company-insights': item.title === 'Private Company Insights',
                    })}
                    >
                      {item.textQuestionMark}
                      {' '}
                      {item.linkQuestionMark && (
                        <a href={item.linkQuestionMark} rel="noreferrer" target="_blank">Learn more.</a>
                      )}
                    </Tooltip>
                  )}
                </div>
              </div>
            </td>
            {item.bodyContent && (
              <td
                className={cx(item.bodyContent.className)}
                rowSpan={item.bodyContent.rowSpan && item.bodyContent.rowSpan}
              >
                {item.bodyContent.text === 'No' && <span className={cx('No')}><FontAwesomeIcon icon={faXmark} /></span>}
                {item.bodyContent.text === 'Yes' && <span className={cx('Yes')}><FontAwesomeIcon icon={faCheck} /></span>}
                {(item.bodyContent.text !== 'Yes' && item.bodyContent.text !== 'No')
                  && item.bodyContent.link
                  && <Link to={item.bodyContent.link}>{item.bodyContent.text}</Link>}
                {(item.bodyContent.text !== 'Yes' && item.bodyContent.text !== 'No')
                  && !item.bodyContent.link
                  && item.bodyContent.text}
                {item.bodyContent.withQuestionMark && (
                  <Tooltip className={cx('question__help', {
                    'sentiment-per-story': item.title === 'Sentiment per Story',
                    'key-headlines': item.title === 'Key Headlines',
                    'analyst-ratings': item.title === 'Analyst ratings',
                    'group-similar-stories': item.title === 'Group or Hide Similar Stories',
                    'investor-relations': item.title === 'Investor relations documents',
                    'private-company-insights': item.title === 'Private Company Insights',
                  })}
                  >
                    {tooltipContent}
                  </Tooltip>
                )}
                {item.bodyContent.textQuestionMark && (
                  <Tooltip className={cx('question__help', {
                    'sentiment-per-story': item.title === 'Sentiment per Story',
                    'key-headlines': item.title === 'Key Headlines',
                    'analyst-ratings': item.title === 'Analyst ratings',
                    'group-similar-stories': item.title === 'Group or Hide Similar Stories',
                    'investor-relations': item.title === 'Investor relations documents',
                    'private-company-insights': item.title === 'Private Company Insights',
                  })}
                  >
                    {item.bodyContent.textQuestionMark}
                    {' '}
                    {item.bodyContent.linkQuestionMark && (
                      <a href={item.bodyContent.linkQuestionMark} rel="noreferrer" target="_blank">Learn more.</a>
                    )}
                  </Tooltip>
                )}
              </td>
            )}
          </tr>
        ))
      }
    </tbody>
  );
};

PricingPlansTableBodyMobile.propTypes = {
  content: PropTypes.instanceOf(Array).isRequired,
};

export default withComponentName(PricingPlansTableBodyMobile);
